import { render, staticRenderFns } from "./eg_svg_text.vue?vue&type=template&id=c3002128&"
import script from "./eg_svg_text.vue?vue&type=script&lang=js&"
export * from "./eg_svg_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports